import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-9dfd4736")

_pushScopeId("data-v-9dfd4736")
const _hoisted_1 = { class: "flex justify-between items-center px-8 pt-2 pb-1 h-12 border-b border-primary-100" }
const _hoisted_2 = { class: "flex items-center" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 学習履歴 ")
const _hoisted_4 = /*#__PURE__*/_createVNode("svg", {
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  viewBox: "0 0 24 24",
  class: "w-4 h-4 mx-2"
}, [
  /*#__PURE__*/_createVNode("path", { d: "M9 5l7 7-7 7" })
], -1)
const _hoisted_5 = { class: "font-medium" }
const _hoisted_6 = /*#__PURE__*/_createVNode("p", null, "学習データを編集", -1)
const _hoisted_7 = { class: "main-panel flex-grow flex flex-col" }
const _hoisted_8 = { class: "flex-grow flex flex-col px-4 pt-6 overflow-y-scroll" }
const _hoisted_9 = {
  key: 0,
  class: "flex items-center p-3 mb-6 rounded-md border-2 border-gray-200 text-yellow-300"
}
const _hoisted_10 = /*#__PURE__*/_createVNode("span", { class: "text-sm font-medium text-gray-500" }, " この学習に対する振り返りは終わっていません ", -1)
const _hoisted_11 = { class: "flex flex-col mb-6" }
const _hoisted_12 = { class: "mb-2 font-medium" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "flex flex-col mb-6" }
const _hoisted_15 = /*#__PURE__*/_createVNode("h3", { class: "mb-2 font-medium" }, "学習科目", -1)
const _hoisted_16 = { class: "text-sm" }
const _hoisted_17 = { class: "flex flex-col mb-6" }
const _hoisted_18 = /*#__PURE__*/_createVNode("h3", { class: "mb-2 font-medium" }, "目標", -1)
const _hoisted_19 = { class: "text-sm" }
const _hoisted_20 = {
  key: 1,
  class: "flex flex-col mb-6"
}
const _hoisted_21 = { class: "mb-2 font-medium" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" 目標の達成度: ")
const _hoisted_23 = { class: "text-secondary-500" }
const _hoisted_24 = { class: "w-full rounded-full bg-gray-200" }
const _hoisted_25 = {
  key: 2,
  class: "flex flex-col mb-6"
}
const _hoisted_26 = /*#__PURE__*/_createVNode("h3", { class: "mb-2 font-medium" }, "目標以外にできたこと", -1)
const _hoisted_27 = { class: "text-gray-700 text-sm" }
const _hoisted_28 = {
  key: 3,
  class: "flex flex-col mb-6"
}
const _hoisted_29 = /*#__PURE__*/_createVNode("h3", { class: "mb-2 font-medium" }, "成果物", -1)
const _hoisted_30 = {
  key: 0,
  class: "flex w-full overflow-x-scroll"
}
const _hoisted_31 = /*#__PURE__*/_createVNode("div", { class: "absolute w-full h-full top-0 left-0 hover:bg-opacity-50 hover:bg-gray-100" }, null, -1)
const _hoisted_32 = {
  key: 1,
  class: "text-gray-700 text-sm"
}
const _hoisted_33 = {
  key: 4,
  class: "flex flex-col mb-6"
}
const _hoisted_34 = /*#__PURE__*/_createVNode("h3", { class: "mb-2 font-medium" }, "感想", -1)
const _hoisted_35 = { class: "text-gray-700 text-sm" }
const _hoisted_36 = {
  key: 5,
  class: "flex flex-col mb-6"
}
const _hoisted_37 = /*#__PURE__*/_createVNode("h3", { class: "mb-2 font-medium" }, "困ったこと・連絡事項・その他", -1)
const _hoisted_38 = { class: "text-gray-700 text-sm" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")
  const _component_m_icon = _resolveComponent("m-icon")
  const _component_m_button = _resolveComponent("m-button")
  const _component_ms_edit_learning_modal = _resolveComponent("ms-edit-learning-modal")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_router_link, {
          to: "../history",
          class: "font-medium text-gray-500 transition-colors duration-300 hover:text-gray-700"
        }, {
          default: _withId(() => [
            _hoisted_3
          ]),
          _: 1
        }),
        _hoisted_4,
        _createVNode("span", _hoisted_5, _toDisplayString(_ctx.date) + "の自習 ", 1)
      ]),
      _createVNode(_component_m_button, {
        color: "gray-500",
        size: "sm",
        "font-weight": "normal",
        text: "",
        class: "hidden lg:flex",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isDisplayEditLearningModal = true))
      }, {
        default: _withId(() => [
          _createVNode(_component_m_icon, {
            type: "pencil",
            class: "mr-2"
          }),
          _hoisted_6
        ]),
        _: 1
      })
    ]),
    _createVNode("div", _hoisted_7, [
      _createVNode("div", _hoisted_8, [
        (!_ctx.existReflection)
          ? (_openBlock(), _createBlock("section", _hoisted_9, [
              _createVNode(_component_m_icon, {
                type: "warning",
                size: "6",
                class: "mr-2"
              }),
              _hoisted_10
            ]))
          : _createCommentVNode("", true),
        _createVNode("section", _hoisted_11, [
          _createVNode("h3", _hoisted_12, "学習時間: " + _toDisplayString(_ctx.learningTimeText), 1),
          (_ctx.sortedRecords.length > 0)
            ? (_openBlock(), _createBlock("ul", _hoisted_13, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sortedRecords, (record) => {
                  return (_openBlock(), _createBlock("li", {
                    key: record.start,
                    class: "text-gray-700 text-sm"
                  }, " • " + _toDisplayString(_ctx.timeTextOf(record)), 1))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]),
        _createVNode("section", _hoisted_14, [
          _hoisted_15,
          _createVNode("p", _hoisted_16, _toDisplayString(_ctx.subjects), 1)
        ]),
        _createVNode("section", _hoisted_17, [
          _hoisted_18,
          _createVNode("p", _hoisted_19, _toDisplayString(_ctx.goal), 1)
        ]),
        (_ctx.existReflection)
          ? (_openBlock(), _createBlock("section", _hoisted_20, [
              _createVNode("h3", _hoisted_21, [
                _hoisted_22,
                _createVNode("span", _hoisted_23, _toDisplayString(_ctx.goalAchievement) + "%", 1)
              ]),
              _createVNode("div", _hoisted_24, [
                _createVNode("div", {
                  class: ["h-2 rounded-full bg-secondary-500", _ctx.achievementCss]
                }, null, 2)
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.existReflection)
          ? (_openBlock(), _createBlock("section", _hoisted_25, [
              _hoisted_26,
              _createVNode("p", _hoisted_27, _toDisplayString(_ctx.additionalContent), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.existReflection)
          ? (_openBlock(), _createBlock("section", _hoisted_28, [
              _hoisted_29,
              (_ctx.images.length > 0)
                ? (_openBlock(), _createBlock("div", _hoisted_30, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.images, (image) => {
                      return (_openBlock(), _createBlock("a", {
                        key: image,
                        href: image,
                        target: "_blank",
                        rel: "noopener noreferrer",
                        class: "flex-none relative mr-4"
                      }, [
                        _createVNode("img", {
                          src: image,
                          alt: "成果物",
                          class: "h-60 w-auto"
                        }, null, 8, ["src"]),
                        _hoisted_31
                      ], 8, ["href"]))
                    }), 128))
                  ]))
                : (_openBlock(), _createBlock("p", _hoisted_32, "-"))
            ]))
          : _createCommentVNode("", true),
        (_ctx.existReflection)
          ? (_openBlock(), _createBlock("section", _hoisted_33, [
              _hoisted_34,
              _createVNode("p", _hoisted_35, _toDisplayString(_ctx.thoughts), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.existReflection)
          ? (_openBlock(), _createBlock("section", _hoisted_36, [
              _hoisted_37,
              _createVNode("p", _hoisted_38, _toDisplayString(_ctx.other), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.isDisplayEditLearningModal)
      ? (_openBlock(), _createBlock(_component_ms_edit_learning_modal, {
          key: 0,
          learning: _ctx.learning,
          student: _ctx.student,
          onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isDisplayEditLearningModal = false))
        }, null, 8, ["learning", "student"]))
      : _createCommentVNode("", true)
  ], 64))
})